var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { attrs: { padding: 5 } },
    [
      _c(
        "Box",
        { attrs: { tag: "header", marginBottom: 5 } },
        [
          _c(
            "layoutText",
            {
              attrs: {
                fontUppercase: "",
                fontSize: 3,
                fontWeight: "bold",
                color: "#222"
              }
            },
            [_vm._v("Void Payment Options")]
          )
        ],
        1
      ),
      _c("FormBuilder", {
        attrs: {
          initial: _vm.initialFormValues,
          form: _vm.formDescription,
          validate: _vm.validate
        },
        on: { submit: _vm.onSubmit },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ main }) {
              return [
                _c(main, { tag: "component" }),
                _c(
                  "Box",
                  {
                    attrs: {
                      marginTop: 7,
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "space-around"
                    }
                  },
                  [
                    _c(
                      "UIButton",
                      {
                        staticClass: "cancel-button",
                        attrs: {
                          type: "button",
                          inverted: true,
                          "margin-left": 3
                        },
                        on: { click: _vm.onCancel }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _c("UIButton", [_vm._v("Submit")])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }